import React, {memo, useRef} from 'react';
import cx from 'classnames';
import {FieldLabel, InputFeedback} from '../index';
import Show from '../../components/Show'
import {arePropsEqual} from '../../util/ReactHelpers';
import TokenInput from 'react-tag-autocomplete';
import invoke from 'lodash.invoke';

function SuggestionComponent ( {item, query} ) {
    return (
        <span id={item.id}
              className="px-4 py-1 m-0 block w-full cursor-pointer hover:bg-near-white active:bg-blue active:text-white">
            {item.name}
        </span>
    )
}

/**
 * Note - This Field is only a Facade and does not store values in Formik state by default
 *  This field accepts a tag list but the parent component must manage it's own
 *  form state using Formik.setFieldValue (onChange, onBlur events will be ignored)
 */
export const TokenizedInput = memo( ( props ) => {
        const {
            id,
            name,
            label,
            labelAppend,
            append,
            prepend,
            hint,
            isFocused,
            mask,
            disabled,
            error,
            errorShown,
            tags,
            tooltip,
            placeholder,
            suggestions,
            suggestionComponent = SuggestionComponent,
            minQueryLength = 1,
            maxSuggestionsLength = 16,
            onAddTag,
            onRemoveTag,
            className,
            tagComponent,
            labelClassName,
            groupClassName,
            inputClassName,
            children,
            ...restProps
        } = props;

        const fieldRef = useRef( null );

        const groupClasses = cx(
            'input-group',
            groupClassName,
            {'animated shake error': !!error || !!errorShown}
        );

        const inputClasses = cx(
            'input-field text-field rounded w-full py-2',
            {'disabled': disabled},
            inputClassName
        );

        const handleInput = ( e ) => {
            invoke( restProps, 'onInput', e );
        }

        const handleFocus = ( e ) => {
            invoke( restProps, 'onFocus', e );
        };

        const handleBlur = ( e ) => {
            invoke( restProps, 'onBlur', e );
        }

        return (
            <div className={cx( 'w-full', {'disabled': disabled}, className )}>
                <FieldLabel
                    label={label}
                    append={labelAppend}
                    tooltip={tooltip}
                    id={id}
                    hint={hint}
                    error={error}
                    className={labelClassName}
                />

                <div className={groupClasses}>
                    <Show when={prepend}>
                        <div className="input-group-prepend">
                            <span className="input-group-text">
                                {prepend}
                            </span>
                        </div>
                    </Show>
                    <Show when={append}>
                       <div className="input-group-append">
                            <span className="input-group-text">
                                {append}
                            </span>
                        </div>
                    </Show>
                    <div className="input-group-input">
                    <div className={inputClasses} style={{height: 'auto'}}>
                        <TokenInput
                            ref={fieldRef}
                            classNames={{
                                // root: 'w-full md:flex-1',
                                // searchInput: 'text-field w-full',
                                root: 'react-tags md:flex flex-auto flex-wrap items-center',
                                rootFocused: 'is-focused',
                                selected: 'react-tags__selected',
                                selectedTag: 'react-tags__selected-tag',
                                selectedTagName: 'react-tags__selected-tag-name',
                                search: 'react-tags__search min-w-2xs flex-auto',
                                searchWrapper: 'react-tags__search-wrapper',
                                searchInput: 'react-tags__search-input text-field ghosted w-full min-w-xs',
                                suggestions: 'react-tags__suggestions absolute bg-white shadow-1 py-2 z-10 min-w-xs max-h-40 overflow-y-auto',
                                suggestionActive: 'is-active',
                                suggestionDisabled: 'is-disabled text-grey'
                            }}
                            placeholderText={placeholder}
                            allowNew={true}
                            autoresize={false}
                            addOnBlur={true}
                            delimiters={['Enter', ',']}
                            tags={tags}
                            suggestions={suggestions}
                            suggestionComponent={suggestionComponent}
                            minQueryLength={minQueryLength}
                            maxSuggestionsLength={maxSuggestionsLength}
                            tagComponent={tagComponent}
                            onBlur={handleBlur}
                            onFocus={handleFocus}
                            onInput={handleInput}
                            onAddition={onAddTag}
                            onDelete={onRemoveTag}
                        />
                    </div>
                </div>
            </div>
            <InputFeedback error={error}/>
        </div>
        );
    }
    ,
    arePropsEqual( [
        'tags',
        'error',
        'errorShown',
        'isFocused',
        'className',
        'groupClassName',
        'inputClassName',
        'children'
    ] ) )

